// src/components/projects/overview/QuickActionsCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box, Typography, Paper, Button, useTheme
} from '@mui/material';
import {
  Add as AddIcon,
  CalendarToday as CalendarIcon,
  ViewKanban as KanbanIcon
} from '@mui/icons-material';
import useTaskStore from '../../../stores/taskStore';

const QuickActionsCard = ({ project, canEdit }) => {
  const theme = useTheme();
  const { openTaskDrawer } = useTaskStore();
  
  // Early return if project is null
  if (!project) {
    return null;
  }
  
  // Handler for opening the task drawer with project context
  const handleCreateTask = () => {
    openTaskDrawer({
      projectId: project._id,
      // Add any other initial context needed
    });
  };
  
  return (
    <Paper sx={{ mb: 3 }}>
      <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
        <Typography variant="h6">
          Quick Actions
        </Typography>
      </Box>
      
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
          <ActionButton 
            to={`/projects/${project._id}/calendar`} 
            icon={<CalendarIcon />}
            label="Calendar"
          />
          
          <ActionButton 
            to={`/projects/${project._id}/kanban`} 
            icon={<KanbanIcon />}
            label="Board"
          />
        </Box>
        
        {canEdit && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleCreateTask}
          >
            Add Task
          </Button>
        )}
      </Box>
    </Paper>
  );
};

// Helper component for action buttons
const ActionButton = ({ to, icon, label }) => (
  <Button
    variant="outlined"
    startIcon={icon}
    component={Link}
    to={to}
    sx={{ justifyContent: 'flex-start' }}
  >
    {label}
  </Button>
);

export default QuickActionsCard;